export default "__VITE_ASSET__DJTYsT_6__"